<template>
  <div id="sales">
    <div class="tabs" :class="{'no-print': inAlternativePrinting}">
      <div v-for="tab of tabs" class="tab" :class="{active: selectedTab === tab.id}" @click="selectedTab = tab.id">{{$t(`processing_status.${tab.id}`)}}</div>
      <div class="filler"></div>
    </div>

    <div :class="{'no-print': inAlternativePrinting}">
      <Datatable
        ref="datatable"
        class="datatable"
        :entity="datableName"
        :parameters="datatableParameters"
        :globalActions="datatableGlobalActions"
        :onRowClick="onRowClick"
      />
    </div>

    <PrintSales v-if="salesToPrint" :sales="salesToPrint" ref="print" />

  </div>
</template>

<script>

  import Datatable from "@/components/Datatable.vue";
  import PrintSales from "@/components/PrintSales.vue";
  import { DateTime } from "luxon";
  import { mapActions } from 'vuex';

  export default {

    name: 'CateringSales',

    components: { Datatable, PrintSales },

    data() {
      return {
        tabs: [
          { id: "in_progress" },
          { id: "upcoming" },
          { id: "completed" }
        ],
        selectedTab: null,
        salesToPrint: null
      }
    },

    computed: {
      inAlternativePrinting() {
        return this.salesToPrint !== null
      },
      companyId() {
        return this.$route.query.company
      },
      datableName() {
        return 'sale_catering_company'
      },
      datatableParameters() {
        return {
          company: this.companyId
        }
      },
      datatableGlobalActions() {
        if (this.selectedTab === 'in_progress') {
          return [{text: 'catering.print_all_sales', method: this.printAllSales }]
        } else {
          return []
        }
      },
      paramsOfSelectedTab() {
        let startOfToday = DateTime.local().startOf('day').toFormat('yyyy-MM-dd HH:mm');
        let startOfTomorrow = DateTime.local().plus({days: 1}).startOf('day').toFormat('yyyy-MM-dd HH:mm');
        if (this.selectedTab === 'in_progress') {
          return {
            from: startOfToday,
            to: startOfTomorrow
          }
        } else if (this.selectedTab === 'upcoming') {
          return {
            from: startOfTomorrow,
            to: undefined
          }
        } else if (this.selectedTab === 'completed') {
          return {
            from: undefined,
            to: startOfToday
          }
        } else {
          return {
            from: undefined,
            to: undefined
          }
        }
      },
    },

    mounted() {
      this.$store.state.pageTitleTranslationKey = "catering.title";
      this.$store.state.pageIcon = "/icon/sales.svg";

      this.selectedTab = 'upcoming';
    },

    watch: {
      selectedTab() {
        let params = this.paramsOfSelectedTab;
        if (!params.from && !params.to) {
          this.$refs.datatable.search.deliveryDate = null;
        } else {
          this.$refs.datatable.search.deliveryDate = `${params.from || ''}|${params.to || ''}`
        }
        this.$refs.datatable.query();
      }
    },

    methods: {
      ...mapActions(["getSalesOfCompany"]),

      onRowClick(row) {
        this.$router.push(this.$router.buildContext("/sale", {id: row.id}));
      },
      async printAllSales() {
        let params = this.paramsOfSelectedTab;
        let query = {
          perPage: -1,
          fromInAdvance: params.from,
          toInAdvance: params.to
        };
        let response = await this.getSalesOfCompany({companyId: this.companyId, query});

        if (response) {
          this.salesToPrint = response.data;
          setTimeout(() => {
            this.$refs.print.print();
            this.salesToPrint = null
          }, 0)
        } else {
          toast(this.$t("error.no_server"), "error");
        }
      }
    }
  };

</script>
<style lang="scss" scoped>
  .datatable {
    height: 100%;
  }
  .tabs {
    margin-bottom: 20px;
  }
</style>